export default __webpack_public_path__ + "static/media/salad@2x.0fe18e3c.jpg";